package presentation.state

import domain.model.ActionCard
import domain.model.PullRequest
import domain.model.OrganizationAccessDiagnosis
import domain.model.OrganizationInvitation
import domain.model.OrganizationInsights
import domain.model.PullRequestInsights
import domain.model.PRViewMode
import ui.theme.ThemeMode

data class AppState(
    val actions: List<ActionCard> = emptyList(),
    val isAuthenticated: Boolean = false,
    val pullRequests: List<PullRequest> = emptyList(),
    val isLoading: Boolean = false,
    val showAddActionModal: Boolean = false,
    val currentTheme: ThemeMode = ThemeMode.LIGHT,
    val showThemeModal: Boolean = false,
    val errorMessage: String? = null,
    val showOrganizationDiagnosis: Boolean = false,
    val isDiagnosingOrganizations: Boolean = false,
    val organizationDiagnosis: OrganizationAccessDiagnosis? = null,
    // Enhanced features state following CLEAN architecture
    val isEnhancedLoading: Boolean = false,
    val enhancedPRs: List<PullRequestInsights> = emptyList(),
    val organizations: List<OrganizationInsights> = emptyList(),
    val pendingInvitations: List<OrganizationInvitation> = emptyList(),
    val currentViewMode: PRViewMode = PRViewMode.ALL_PRS,
    // Settings modal state
    val showSettingsModal: Boolean = false
)
